import Decimal from 'decimal.js'

export const sumDecimal = (list: Decimal[]) => {
    return list.reduce((a, p) => a.plus(p), new Decimal(0))
}
